import { render, staticRenderFns } from "./CalendarComp.vue?vue&type=template&id=5f8f3df7&scoped=true&"
import script from "./CalendarComp.vue?vue&type=script&lang=js&"
export * from "./CalendarComp.vue?vue&type=script&lang=js&"
import style0 from "./CalendarComp.vue?vue&type=style&index=0&id=5f8f3df7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8f3df7",
  null
  
)

export default component.exports